// extracted by mini-css-extract-plugin
export default {"link":"Tz-z","disabled":"Uz-z"};